import React from 'react';
import { useHistory } from 'react-router-dom';
import useFormProcessor from '../../hooks/useFormProcessor';

import { setCookie, getCookie } from '../../utils/cookie';

import { createProject } from '../../services/projects.service';
import { getEmptyInputsErrorsObject } from '../../utils/errors/project';
import { validateKey, validateName } from '../../utils/validations/project';

import ErrorMessageContainer from '../form-input-error-message';
import InfoMessageContainer from '../form-input-info-message';

import FormInput from '../form-input';
import FormButton from '../button-form';

const initialProject = {
	Name: '',
	Key: '',
	BaleId: ''
};

const CreateProjectForm = () => {
	const { data, errors, handleChange, handleOnBlur, handleSubmit } = useFormProcessor(initialProject, initialProject);
	const history = useHistory();

	const getErrors = () => {
		const { Name, Key, BaleId } = data;
		return getEmptyInputsErrorsObject({ Name, Key, BaleId });
	};

	const handleCreateProject = async () => {
		const token = getCookie('x-auth-token');
		const { Name, Key, BaleId } = data;
		const result = await createProject({ Name, Key,BaleId }, token);

		if (result.Token) {
			setCookie('x-auth-token', result.Token);
			history.push('/user/projects');
		}
	};

	return (
		<form
			onSubmit={(e) => handleSubmit(e, getErrors(), handleCreateProject)}
			className="lg:w-2/6 md:w-1/2 rounded-lg p-8 flex flex-col md:ml-0 w-full mt-10 md:mt-0"
		>
			<h2 className="text-gray-900 text-lg font-medium title-font mb-5">ایجاد پروژه</h2>
			<FormInput
				handleChange={handleChange}
				handleOnBlur={(event) => handleOnBlur(event, validateName, { Name: data.Name })}
				type="text"
				name="Name"
				value={data.Name}
				placeholder="نام پروژه"
			/>
			{errors.Name ? <ErrorMessageContainer>{errors.Name}</ErrorMessageContainer> : null}

			<FormInput
				type="text"
				name="Key"
				placeholder="شناسه پروژه"
				value={data.Key}
				handleChange={handleChange}
				handleOnBlur={(event) => handleOnBlur(event, validateKey, { Key: data.Key })}
			/>

			{errors.Key ? (
				<ErrorMessageContainer>{errors.Key}</ErrorMessageContainer>
			) : (
				<InfoMessageContainer>
					یک شناسه کوتاه با معنی برای پروژه خودتان انتخاب نمایید
				</InfoMessageContainer>
			)}

			
			<FormInput
				type="text"
				name="BaleId"
				placeholder="شناسه گفتگو"
				value={data.BaleId}
				handleChange={handleChange}
			/>
			<FormButton addClass="mt-4">ایجاد</FormButton>
		</form>
	);
};

export default CreateProjectForm;
